import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/layouts/default.vue").then(m => m.default || m)),
  plain: defineAsyncComponent(() => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/layouts/plain.vue").then(m => m.default || m))
}